import React, { useEffect } from "react";
import "./Shop_Banner.css";
import { useNavigate } from "react-router-dom";
import { getCoupons } from "../../../features/home/homeSlice";
import { useDispatch, useSelector } from "react-redux";

const Shop_Banner = (props) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const coupons = useSelector((state) => state.home.addCoupons);

  useEffect(() => {
    dispatch(getCoupons({}));
  }, [dispatch]);

  return (
    <section
      className="Shop_Banner"
      // onClick={() => {
      //   navigate(`/product-listing/${props?.id}`);
      // }}
    >
      <div className="row">
        <div className="col-md-8 col-8">
          <div className="img_holder">
            {Array.isArray(coupons?.data) && coupons.data[0]?.image && (
              <img
                src={process.env.REACT_APP_IMG_URL + coupons.data[0].image}
                alt="Coupon Banner"
                className="banner_img"
              />
            )}
          </div>
        </div>
        <div className="col-md-4 col-4">
          <div className="banner_list_holder">
            <div className="row">
              {coupons?.data?.slice(1).map((val, index) => (
                <div className="col-12 banner_list_img_holder">
                  <div className="img_holder">
                    <img
                      src={process.env.REACT_APP_IMG_URL + val?.image}
                      className="banner_img"
                    />
                  </div>
                </div>
              ))}
              {/* <div className="col-12 banner_list_img_holder">
                <div className="img_holder">
                  <img
                    src="/assets/images/shop/shop_banner.png"
                    className="banner_img"
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Shop_Banner;
